import { useEffect } from 'react';
import { metrics } from '../../timers/metrics/metrics';
import { timers } from '../../timers/timers';

type DocumentMetricsProps = { annotationId: number };
export const DocumentMetrics = ({ annotationId }: DocumentMetricsProps) => {
  useEffect(() => {
    if (
      !timers.isRunning('fe_document_ready_after_action', 'annotation_open')
    ) {
      metrics.startAnnotationOpen(annotationId);
    }
  }, [annotationId]);

  return null;
};
